import { DEFAULT_GETTERS } from '@/modules/sale/constants';

export default {
  ...DEFAULT_GETTERS,
  user: (state) => state.user,
  updateProfile: (state) => state.updateProfile,
  cropImg: (state) => state.cropImg
};
